export default {
    topics: [
        {
            title: ' CheckUrlFormat ',
            href: 'sm-purl-CheckUrlFormat.html',
            attributes: { 'data-id': 'sm-purl-CheckUrlFormat' },
            menu: { hasChildren: false },
            tocID: 'sm-purl-CheckUrlFormat-d66e3599',
            topics: [],
        },
        {
            title: ' ComputeUrl ',
            href: 'sm-purl-ComputeUrl.html',
            attributes: { 'data-id': 'sm-purl-ComputeUrl' },
            menu: { hasChildren: false },
            tocID: 'sm-purl-ComputeUrl-d66e3607',
            topics: [],
        },
        {
            title: ' Publish ',
            href: 'sm-purl-Publish.html',
            attributes: { 'data-id': 'sm-purl-Publish' },
            menu: { hasChildren: false },
            tocID: 'sm-purl-Publish-d66e3615',
            topics: [],
        },
    ],
};

